import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { UserSettingsValues } from "@/shared/services/common/type/common.type";
import { ThemeType } from "@/shared/type/type";

interface ProfileState {
  theme: ThemeType;
  language: string;
  settings: UserSettingsValues | null;
}

const initialState: ProfileState = {
  theme: "light",
  language: "en",
  settings: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeType>) => {
      state.theme = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setUserSettings: (
      state,
      action: PayloadAction<UserSettingsValues | null>,
    ) => {
      state.settings = action.payload;

      if (action.payload?.themeType) {
        state.theme =
          action.payload.themeType.toLowerCase() === "dark" ? "dark" : "light";
      }
    },
  },
});

export const { setTheme, setLanguage, setUserSettings } = profileSlice.actions;

export default profileSlice.reducer;
